import { useCallback } from 'react';
import { Autocomplete } from '../Autocomplete';
import { useFleetModels, type FleetModel } from '../../hooks/useFleetModels';
export type { FleetModel } from '../../hooks/useFleetModels';

interface FleetComboboxProps {
  id: string;
  label: string;
  required?: boolean;
  placeholder?: string;
  initialFleetModel?: FleetModel | null;
  onValueChange: (value: string) => void;
  onFleetModelSelect?: (item: FleetModel) => void;
  error?: string;
}

export function FleetCombobox({
  id,
  label,
  required = false,
  placeholder = 'e.g., Boeing 737-800',
  initialFleetModel,
  onValueChange,
  onFleetModelSelect,
  error,
}: FleetComboboxProps) {
  const { searchFleetModels } = useFleetModels();

  const getFleetModelLabel = useCallback(
    (item: FleetModel) => (item.classification ? `${item.name} (${item.classification})` : item.name),
    [],
  );

  const handleSelect = useCallback(
    (item: FleetModel) => {
      onValueChange(item.name);
      onFleetModelSelect?.(item);
    },
    [onValueChange, onFleetModelSelect],
  );

  return (
    <div>
      <label htmlFor={id} className="block text-sm font-medium text-navy mb-1">
        {label}
        {required && <span className="text-red-500 ml-0.5">*</span>}
      </label>
      <Autocomplete<FleetModel>
        id={id}
        fetchResults={searchFleetModels}
        getLabel={getFleetModelLabel}
        getKey={(item) => item.id}
        onSelect={handleSelect}
        onInputChange={onValueChange}
        placeholder={placeholder}
        initialItem={initialFleetModel ?? undefined}
      />
      {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
    </div>
  );
}
